import { defineComponent as r, createBlock as n, openBlock as a, unref as l, mergeProps as p, withCtx as c, createElementVNode as i } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const u = /* @__PURE__ */ r({
  name: "IconSearchFilled",
  __name: "IconSearchFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (s, e) => (a(), n(l(m), p(o, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        i("path", { d: "M2.125 9.875a7.75 7.75 0 1 1 13.892 4.727l5.565 5.566a1 1 0 0 1-1.414 1.414l-5.566-5.565A7.75 7.75 0 0 1 2.125 9.875" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
